import { IsIn } from 'class-validator';
import { TIMEZONE_OPTIONS } from '../data';

export type SupportedTimezone = (typeof TIMEZONE_OPTIONS)[number]['id'];

export class TimezoneDto {
  @IsIn(TIMEZONE_OPTIONS.map((t) => t.id))
  timezone!: SupportedTimezone;
}
